import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        about_info: [],
        projects_info: [],
    },
    mutations: {
        SET_ABOUT_INFO(state, about_info) {
            state.about_info = about_info;
        },
        SET_PROJECTS_INFO(state, projects_info) {
            state.projects_info = projects_info;
        },
    },
    actions: {
        fetchAboutData({ dispatch }) {
            // The place where you do the async calls to backend
            return new Promise(resolve => {
                setTimeout(async () => {
                    const about_info = await (await fetch("data/about.json")).json(); // Assume nothing goes wrong since local

                    // Manually parse double moustache
                    for (let i = 0; i < about_info.length; i++) {
                        for (let j = 0; j < about_info[i].paragraphs.length; j++) {
                            about_info[i].paragraphs[j] = about_info[i].paragraphs[j].replace(
                                "{{age}}",
                                await dispatch("getAge")
                            );
                        }
                    }
                    resolve(about_info);
                });
            });
        },
        async fetchAbout({ dispatch, commit }) {
            const aboutJson = await dispatch("fetchAboutData");
            commit("SET_ABOUT_INFO", aboutJson);
        },
        fetchProjectsData() {
            // The place where you do the async calls to backend
            return new Promise(resolve => {
                setTimeout(async () => {
                    const res_projects = await fetch("data/projects.json");
                    const val_projects = await res_projects.json();
                    resolve(val_projects);
                });
            });
        },
        async fetchProjects({ dispatch, commit }) {
            const projectsJson = await dispatch("fetchProjectsData");
            commit("SET_PROJECTS_INFO", projectsJson);
        },
        async search({ commit, dispatch }, { text }) {
            // Fetch projects
            const myJson = await dispatch("fetchProjectsData");

            // Check if valid input
            if ((text == null) || (text.length == 0)) {
                commit("SET_PROJECTS_INFO", myJson);
                return
            }

            // Keywords to filter on, split on non-alphabetic characters
            const keywords = text
                .toLowerCase()
                .split(/[^a-z]/)
                .filter(el => el.length > 0);

            // Filter for potential matches
            const values = myJson.filter(
                val =>
                    keywords.some(el => val.title.toLowerCase().includes(el)) |
                    keywords.some(el => val.text.toLowerCase().includes(el)) |
                    keywords.some(el => val.keywords.join(", ").toLowerCase().includes(el))
            );

            // if (matches found) ? (return matches) : (return 404 project)
            if (values.length > 0) {
                commit("SET_PROJECTS_INFO", values);
            } else {
                const no_info = [
                    {
                        title: "Under Construction",
                        text: "No projects found that match your suggestions, but I'm all ears if you have any suggestions!",
                        keywords: [text],
                        date: "20??-??-??",
                        url: "https://github.com/RubenPants",
                        image: "construction.png",
                    }
                ];
                commit("SET_PROJECTS_INFO", no_info);
            }
        },
        getAge() {
            const birthday = +new Date("1997-05-15");
            return ~~((Date.now() - birthday) / 31557600000);
        }
    },
    getters: {
        about_info(state) {
            return state.about_info;
        },
        projects_info(state) {
            return state.projects_info;
        }
    },
});
